'use client';

import { forwardRef } from 'react';
import * as CollapsiblePrimitive from '@radix-ui/react-collapsible';
import { cn } from "../utils";
import { jsx as _jsx } from "react/jsx-runtime";
var Collapsible = CollapsiblePrimitive.Root;
var CollapsibleTrigger = CollapsiblePrimitive.CollapsibleTrigger;
var CollapsibleContent = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    className = _ref.className;
  return /*#__PURE__*/_jsx(CollapsiblePrimitive.CollapsibleContent, {
    ref: ref,
    className: cn(className, 'tw-overflow-hidden data-[state=open]:tw-animate-radix-slide-down data-[state=closed]:tw-animate-radix-slide-up'),
    children: children
  });
});
export { Collapsible, CollapsibleTrigger, CollapsibleContent };